module.exports = __webpack_public_path__ + "img/VRP-logo-military.84c10a83.svg";